<template>
  <div class="registerWrap">
    <v-card max-width="600px" class="mx-auto mt-10">
      <v-card-text>
        <Register></Register>
      </v-card-text>
    </v-card>
    <div class="text-center mt-3">
      <router-link :to="{name:'home'}">zur Startseite</router-link>
    </div>
  </div>
</template>

<script>
import Register from "./../../components/baseSystem/Register.vue"
export default {
  components:{ Register }
}
</script>
